import { render, staticRenderFns } from "./UserAgreementLess.vue?vue&type=template&id=4c7d85ed&scoped=true"
import script from "./UserAgreementLess.vue?vue&type=script&lang=js"
export * from "./UserAgreementLess.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementLess.vue?vue&type=style&index=0&id=4c7d85ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d85ed",
  null
  
)

export default component.exports